export default "__VITE_ASSET__BjcDgbXQ__"